import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { MeasureDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-measure-container',
  templateUrl: './measure-container.component.html',
  styleUrls: ['./measure-container.component.scss']
})
export class MeasureContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  measures$: Observable<MeasureDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("Measure");
    this.measures$ = this.gatwayFacade.loadGateway("Measure");
    this.measures$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteMeasure(deletedValue: any) {
    this.gatwayFacade.remove("Measure", deletedValue);
    // this.store.dispatch(MeasureStoreActions.removeMeasure({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitMeasure(formValue: any) {
    console.log("form value: ", formValue);
    formValue.Measures = formValue.Measures.reverse();
    event.preventDefault();
    const pullData = formValue.Measures;
    //const newPullData = formValue.Measurees;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllMeasure = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllMeasure.push(pullData[i]);
    }
  }

// check if the addAllMeasure array is not empty, then dispatch the data to the store
   if(addAllMeasure.length !== 0) {
    this.gatwayFacade.add('Measure', addAllMeasure);
    // this.store.dispatch(MeasureStoreActions.addMeasure({newMeasure: addAllMeasure}));

   }

// dispatch update data to the store
this.gatwayFacade.update('Measure', allUpdates, ['id']);
    // this.store.dispatch(MeasureStoreActions.updateMeasure({updateMeasure: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}



